module.exports = __webpack_public_path__ + "static/media/updateuser.5442e7cb.svg";